import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import configure from "configure";
// assets
import "../../../../assets/css/Sales/Sales.css";

// tabId: which verticalActiveTab value means "this tab is active" in the
// parent's own numbering scheme -- View Lead (index.js) and Edit Lead use
// different tab layouts, so this can't be hardcoded.
const ViewProposals = ({ leadId, verticalActiveTab, tabId = "6" }) => {
    const navigate = useNavigate();
    const [proposal, setProposal] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchProposals = async () => {
        if (!leadId) return;
        setLoading(true);
        try {
            const token = secureLocalStorage.getItem("auth_token");
            const res = await axios.get(
                `${configure.nodeApi}/get_proposal_by_lead/${leadId}`,
                { headers: { Accept: "application/json", Authorization: `Bearer ${token}` } },
            );
            setProposal(res?.data?.data || null);
        } catch (err) {
            console.log(err);
            setProposal(null);
        }
        setLoading(false);
    };

    useEffect(() => {
        if (verticalActiveTab === tabId) fetchProposals();
    }, [verticalActiveTab, tabId, leadId]);

    const onDelete = (id) => {
        swal({
            title: "Are you sure?",
            text: "You want to Delete this Proposal !",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (!willDelete) return;
            const formData = new FormData();
            formData.append("user_id", localStorage.getItem("auth_id"));
            formData.append("proposal_id", id);
            try {
                await axios({
                    method: "post",
                    url: `${configure.nodeApi}/delete_proposal`,
                    data: formData,
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                    },
                });
                swal({ icon: "success", text: "Proposal Deleted Successfully" }).then(
                    () => fetchProposals(),
                );
            } catch (err) {
                console.log(err);
                swal({ icon: "error", text: "Something went wrong" });
            }
        });
    };

    return (
        <React.Fragment>
            <div className="mb-3">
                <Row>
                    <Col lg="12">
                        <Card>
                            <CardBody>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <CardTitle className="mb-0">Proposals</CardTitle>
                                    {!proposal && (
                                        <a
                                            href={`${configure.appUrl}sales/add-proposal?related=lead&source_id=${leadId}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="btn btn-sm btn-purple"
                                        >
                                            <i className="fas fa-plus me-1"></i>
                                            New Proposal
                                        </a>
                                    )}
                                </div>
                                <div className="responsive-table table-responsive">
                                    <table className="table table-bordered mb-0 table-striped table-hover">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Title</th>
                                                <th>Type</th>
                                                <th>Status</th>
                                                <th>Date</th>
                                                <th>Open Till</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!proposal ? (
                                                <tr>
                                                    <td className="text-center" colSpan={6}>
                                                        {loading ? "Loading..." : "No Proposals Available"}
                                                    </td>
                                                </tr>
                                            ) : (
                                                <tr>
                                                    <td>{proposal?.proposaltitile || "-"}</td>
                                                    <td>{proposal?.type || "-"}</td>
                                                    <td>{proposal?.status_name || "-"}</td>
                                                    <td>
                                                        {proposal?.date
                                                            ? moment(proposal.date).format("DD-MM-YYYY")
                                                            : "-"}
                                                    </td>
                                                    <td>
                                                        {proposal?.opentill
                                                            ? moment(proposal.opentill).format("DD-MM-YYYY")
                                                            : "-"}
                                                    </td>
                                                    <td>
                                                        <div className="d-flex">
                                                            <a
                                                                href={`${configure.appUrl}sales/edit-proposal/${proposal.id}`}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                title="View Proposal"
                                                                className="btn btn-sm btn-outline-secondary me-1"
                                                            >
                                                                <i className="fas fa-eye"></i>
                                                            </a>
                                                            <a
                                                                onClick={() =>
                                                                    navigate(
                                                                        `${configure.appUrl}sales/edit-proposal/${proposal.id}`,
                                                                    )
                                                                }
                                                                title="Edit Proposal"
                                                                className="btn btn-sm btn-outline-secondary me-1"
                                                            >
                                                                <i className="fas fa-pencil-alt"></i>
                                                            </a>
                                                            <a
                                                                onClick={() => onDelete(proposal.id)}
                                                                title="Delete Proposal"
                                                                className="btn btn-sm btn-outline-secondary"
                                                            >
                                                                <i className="fas fa-trash-alt text-danger"></i>
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    );
};

export default ViewProposals;
